import React, { useEffect, useState } from "react";
import { Form, Input, Button, Card, message, Divider } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { completeRegister, resetRegister } from "../../actions/auth/genesis";
import Swal from "sweetalert2";

function GenesisVerify() {
  const [verificationCode, setVerificationCode] = useState("");
  const [lastCode, setLastCode] = useState(null); // Son gönderilen kodu saklar

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { spinner, error, responseMessage, completeData } = useSelector(
    (state) => state.genesis
  );

  const phoneNumber = localStorage.getItem("phoneNumber");

  useEffect(() => {
    if (completeData) {
      message.success("Doğrulama başarılı! Lütfen giriş yapınız.");
      dispatch(resetRegister());
      navigate("/login");
    } else if (error) {
      if (error?.status === 429) {
        Swal.fire({
          icon: "error",
          title: "Erişim Kısıtlandı",
          text: "Yaptığınız işlemler sunucularımıza olağandışı bir yük oluşturduğundan, erişiminizi kısıtladık. Bu durum, hesabınızın güvenliği veya sistemimizin düzgün çalışması için alınan bir önlemdir. Lütfen destek ekibimizle iletişime geçin. Anlayışınız için teşekkür ederiz!",
          footer: `
            <div>
              <a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>
              <br>
              <a href="tel:+903129060708">📞 +90 (312) 906 07 08</a>
              <br>
              <a href="tel:+908504500606">📞 0 (850) 450 06 06</a>
            </div>
          `,
        });        
      } else if (responseMessage) {
        message.error(responseMessage);
      }
    }
  }, [completeData, error, responseMessage, navigate, dispatch]);

  const handleSubmit = () => {
    if (!verificationCode) {
      message.error("Doğrulama kodu zorunludur!");
      return;
    }

    // Eğer yeni girilen kod, son gönderilen kodla aynıysa uyarı göster ve işlem yapma
    if (verificationCode === lastCode) {
      message.warning("Hatalı olan doğrulama kodunu tekrar kullanamazsınız!");
      return;
    }

    // Kod farklıysa işlem yap ve son gönderilen kodu güncelle
    setLastCode(verificationCode);
    dispatch(completeRegister(phoneNumber, verificationCode));
  };

  return (
    <div className="flex justify-center items-center max-h-screen md:h-screen bg-gray-100">
      <Card
        className="shadow-xl p-4 w-full max-w-full md:max-w-[600px] h-screen md:h-[300px] "
      >
        <div className="flex justify-between">
          <div>
            <h2 className="block text-lg font-bold text-gray-800 mb-5">
              Doğrulama
            </h2>
          </div>
          <div className="w-14">
            <img
              src="https://www.onedose.io/wp-content/uploads/2020/09/onedose_black.png"
              alt="logo"
            />
          </div>
        </div>
        <p className="text-start mb-4">
          Telefon numaranıza gönderilen doğrulama kodunu giriniz.
        </p>
        <Divider />
        <Form layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            label="Doğrulama Kodu"
            name="verificationCode"
            rules={[
              { required: true, message: "Doğrulama kodu zorunludur!" },
              {
                len: 6,
                message: "Doğrulama kodu 6 haneli olmalıdır!",
              },
            ]}
          >
            <Input
              maxLength={6}
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value)}
              placeholder="6 haneli kod"
            />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              className="w-full"
              loading={spinner}
            >
              Doğrula
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}

export default GenesisVerify;
